import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as delayReasonsServiceClear } from './delayReasonsService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'delayReasons',
  serviceTableName: 'delayReasonsService',
  serviceClearFunction: delayReasonsServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.delayReason]),
});
